import React from "react"
import PhoneInputValidate from "@features/Demo/Inline/DemoComponents/PhoneValidate/PhoneInputValidate"
import SiteInputValidate from "@features/Demo/Inline/DemoComponents/SiteValidate/SiteInputValidate"
import DropdownInput from "@features/Demo/Inline/DemoComponents/DropdownInput/DropdownInput"
import * as s from "../DemoHorStyle.module.scss"
import * as style from "@shared/ui/Forms/Legal/style.module.scss"
import { isValidName, roleOptions, trafficOptions } from "@shared/forms"

export default function FormFields({
  formData,
  setFormData,
  errors,
  touched,
  setTouched,
  openDropdown,
  setOpenDropdown,
  phoneValid,
  setPhoneValid,
  setPhoneTouched,
  isNameValid,
  setIsNameValid,
  checked,
  setChecked,
  isFormValid,
  onDropdownChange,
}) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    setTouched((prev) => ({ ...prev, [name]: true }))
    if (name === "name") {
      setIsNameValid(isValidName(value))
    }
  }

  return (
    <>
      <div>
        <h4>Контакты</h4>
        <div className={s.blockForm}>
          <div className={s.customPlaceholder}>
            <label htmlFor="name" className={`${s.customLabel} ${formData.name ? s.hidden : ""}`}>
              Имя <span className={s.required}>*</span>
            </label>
            <input
              name="name"
              id="name"
              className={`${formData.name ? (isNameValid ? s.success : s.invalid) : ""}`}
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <PhoneInputValidate
            onChange={(value) => setFormData((prev) => ({ ...prev, phone: value }))}
            onValidationChange={setPhoneValid}
            onTouchedChange={() => setPhoneTouched(true)}
          />
          <DropdownInput
            label="Роль"
            name="role"
            onChange={onDropdownChange}
            options={roleOptions}
            value={formData.role}
            className={errors.role ? s.invalid : ""}
            required
            isOpen={openDropdown === "role"}
            setOpenDropdown={setOpenDropdown}
          />
        </div>
      </div>

      <div>
        <h4>О компании</h4>
        <div className={s.blockForm}>
          <SiteInputValidate onChange={(value) => setFormData((prev) => ({ ...prev, site: value }))} />
          <DropdownInput
            label="Трафик"
            name="traffic"
            onChange={onDropdownChange}
            options={trafficOptions}
            value={formData.traffic}
            className={`${errors.traffic ? s.invalid : ""} ${s.lastDrop}`}
            required
            isOpen={openDropdown === "traffic"}
            setOpenDropdown={setOpenDropdown}
          />
        </div>

        <button type="submit" disabled={checked} className={`${s.btn} ${!isFormValid || checked ? s.disabled : ""}`}>
          Отправить заявку
        </button>

        <div className={s.legal}>
          <div onClick={() => setChecked(!checked)}>
            {checked ? (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_17982_544)">
                  <path
                    d="M4 1H28C29.6569 1 31 2.34315 31 4V28C31 29.6569 29.6569 31 28 31H4C2.34315 31 1 29.6569 1 28V4C1 2.34315 2.34315 1 4 1Z"
                    fill="white"
                    stroke="#FF7C16"
                    strokeWidth="2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_17982_544">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            ) : (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_17982_544)">
                  <path
                    d="M28 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0Z"
                    fill="#FF7C16"
                  />
                  <path d="M8 16.6111L12.9231 21.5L24 10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_17982_544">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
          </div>
          <p id="legalPhone" className={style.wrapper}>
            Нажимая на кнопку, вы даете
            <a href="/terms-and-policies/soglasie-5/" target="_blank">
              {" "}
              согласие{" "}
            </a>
            на обработку
            <a href="/terms-and-policies/" target="_blank">
              {" "}
              персональных данных
            </a>
          </p>
        </div>
      </div>
    </>
  )
}
